<template>
    <ValidationObserver ref="changeMajorForm">
        <b-container class="mt-5">
            <b-row>
                <b-col>
                    <b-card class="p-5">
                        <b-row class="text-center">
                            <b-col cols="12" class="d-flex align-items-center justify-content-between mb-3">
                                <img src="../../../assets/img/BAU_Logo.png" height="75" alt="BAU Logo" />
                                <h6 class="mb-0" v-html="$t('bau_inspiration_text')"></h6>
                            </b-col>
                            <b-col>
                                <h4 class="mt-3 font-weight-bold">{{ $t('change_of_major_form') }}</h4>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <p v-html="$t('change_of_major_form_description')"></p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="student_name" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('student_name')">
                                        <b-form-input v-model="form.student_name" :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="student_id" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('student_id')">
                                        <b-form-input v-model="form.student_id" :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="address" rules="" v-slot="{ errors }">
                                    <b-form-group label="Mailing Address">
                                        <b-form-input v-model="form.address" />
                                        <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="email" rules="email" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('email')">
                                        <b-form-input v-model="form.email" :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="mobile_tel" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('phone_number')">
                                        <b-input-group
                                            class="mb-3 flex-nowrap"
                                            prepend="*"
                                        >
                                        <b-form-input v-mask="'+1 (###)-###-####'" v-model="form.mobile_tel" :class="errors[0] ? 'is-invalid' : ''" />
                                        </b-input-group>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="sevis_id" rules="" v-slot="{ valid, errors }">
                                    <b-form-group label="Student SEVIS ID (F-1)">
                                        <b-form-input v-model="form.sevis_id" :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="start_year" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('start_year')">
                                        <b-form-input v-model="form.start_year" type="number" :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="start_semester" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('start_semester')">
                                        <b-form-input v-model="form.start_semester" type="number" :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12">
                                <h5>{{ $t('current_program_of_study') }}</h5>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="current_undergraduate" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('undergraduate')">
                                        <b-form-checkbox-group
                                            v-model="form.current_program"
                                            class="d-flex flex-wrap b-form-group-horizontal"
                                            :options="undergraduateOptions"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            stacked
                                        ></b-form-checkbox-group>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="current_graduate" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('graduate')">
                                        <b-form-checkbox-group
                                            v-model="form.current_program"
                                            class="d-flex flex-wrap b-form-group-horizontal"
                                            :options="graduateOptions"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            stacked
                                        ></b-form-checkbox-group>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <p class="font-weight-bold" v-html="$t('form_submission_note')"></p>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="student_signature" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('student_signature')">
                                        <b-form-input v-model="form.student_signature" :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="date" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('date')">
                                        <select-date v-model="form.date" :validation-error="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="advisor_signature" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('advisor_signature')">
                                        <b-form-input v-model="form.advisor_signature" :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="advisor_date" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('date')">
                                        <select-date v-model="form.advisor_date" :validation-error="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </ValidationObserver>
</template>
<script>
import SelectDate from "@/components/interactive-fields/SelectDate.vue";

export default {
    components: {
        SelectDate
    },
    data() {
        return {
            form: {
                student_name: null,
                student_id: null,
                email: null,
                sevis_id: null,
                start_year: null,
                start_semester: null,
                current_program: [],
                new_program: [],
                rationale: null,
                student_signature: null,
                date: null,
                advisor_signature: null,
                advisor_date: null
            },
            semesterOptions: [
                { value: 'Fall', text: 'Fall' },
                { value: 'Spring', text: 'Spring' },
                { value: 'Summer', text: 'Summer' }
            ],
            undergraduateOptions: [
                { value: 'Undergraduate - Business Administration and Management', text: 'Undergraduate - Business Administration and Management' },
                { value: 'Undergraduate - Economics and Finance', text: 'Undergraduate - Economics and Finance' },
                { value: 'Undergraduate - Data Science', text: 'Undergraduate - Data Science' },
                { value: 'Undergraduate - Information Technology', text: 'Undergraduate - Information Technology' },
                { value: 'Undergraduate - Software Engineering', text: 'Undergraduate - Software Engineering' },
                { value: 'Undergraduate - Political Science and International Relations', text: 'Undergraduate - Political Science and International Relations' }
            ],
            graduateOptions: [
                { value: 'Graduate - Master of Business Administration (MBA)', text: 'Graduate - Master of Business Administration (MBA)' },
                { value: 'Graduate - MS in Cyber Security', text: 'Graduate - MS in Cyber Security' },
                { value: 'Graduate - MS in Big Data Analytics', text: 'Graduate - MS in Big Data Analytics' },
                { value: 'Graduate - Dual Master’s Degree - MBA and Big Data Analytics', text: 'Graduate - Dual Master’s Degree - MBA and Big Data Analytics' },
                { value: 'Graduate - MS in Artificial Intelligence', text: 'Graduate - MS in Artificial Intelligence' },
                { value: 'Graduate - MS in Software Engineering', text: 'Graduate - MS in Software Engineering' },
                { value: 'Graduate - MS in Cloud Engineering', text: 'Graduate - MS in Cloud Engineering' }
            ]
        };
    },
    metaInfo() {
        return {
            title: this.$t("change_of_major_form"),
        };    
    },
    methods: {}
};
</script>
<style scoped>
.yellow-line {
    border-top: 2px solid #ffc107; /* Yellow line */
}
</style>